import { AxiosPromise, AxiosRequestConfig } from "axios";

import { oc } from "ts-optchain";
import { IMockRouteConfig, Mockios } from "./Mockios";

import { MockRouteMatcher } from "./MockRouteMatcher";

import {
    IPartApplicationDto,
    IPartCrossReferenceDto,
    IPartDetailComponentInfo,
    IPartDetailCoreDeductionItem,
    IPartDetailGeneralInfo,
    IOrderHistoryByPart,
    IPartDetailRelatedPartItem,
    IPartDetailResponse,
    IPartDetailSupersession,
    MessageStatusType,
    PartValidationReason,
    IFullPartDetailWithStatusDto,
    Source
} from "@/types";

import { CONTROLLER_PATH, IGetPartDetailRequest } from "./PartDetailServices";

export class PartDetailMockService {
    public static getRoutes(): IMockRouteConfig[] {
        return [
            {
                result: this.getPartDetailFactory,
                isMatch: (rq) => MockRouteMatcher.isMethodAndPathMatch("get", `${CONTROLLER_PATH}/Detail`, rq),
            },
            {
                result: this.getCrossReferencesFactory,
                isMatch: (rq) => MockRouteMatcher.isMethodAndPathMatch("get", `${CONTROLLER_PATH}/CrossReferences`, rq),
            },
            {
                result: this.getHistoryFactory,
                isMatch: (rq) => MockRouteMatcher.isMethodAndPathMatch("get", `${CONTROLLER_PATH}/History`, rq),
            },
            {
                result: this.getComponentsFactory,
                isMatch: (rq) => MockRouteMatcher.isMethodAndPathMatch("get", `${CONTROLLER_PATH}/Components`, rq),
            },
            {
                result: this.getPartApplicationsFactory,
                isMatch: (rq) => MockRouteMatcher.isMethodAndPathMatch("get", `${CONTROLLER_PATH}/Applications`, rq),
            },
            {
                result: this.getSupersessionFactory,
                isMatch: (rq) => MockRouteMatcher.isMethodAndPathMatch("get", `${CONTROLLER_PATH}/Supersession`, rq),
            },
        ];
    }

    private static getPartDetailFactory(request: AxiosRequestConfig): AxiosPromise<IFullPartDetailWithStatusDto> {
        const code = oc(request.params as IGetPartDetailRequest).oemPartCode("NOT FOUND");

const RM00000063: IFullPartDetailWithStatusDto = {
  "PartStatusMessage": {
    "IsOrderable": true,
    "ShortMessage": null,
    "LongMessage": null,
    "PartValidationReason": 1,
    "ReplacementPartOemPartCode": null,
    "ReplacementPartId": 0,
    "ReplacementPartsCount": 0,
    "MessageStatusType": 0,
    "ComponentPartsCount": 0
  },
  "Validation": {
    "IsValid": true,
    "ValidationReason": 1,
    "RequestedPart": null,
    "ReplacementPartOemPartCode": null,
    "ReplacementPartId": 0,
    "OemPartCode": "RM00000003",
    "UniqueItemId": 4019128,
    "ReplacementPartsCount": 0,
    "IsOrderable": true,
    "PrimaryVendorNumber": "2004",
    "DealerNetPrice": 264,
    "FleetListPrice": 396,
    "ContractPrice": 264,
    "BillingCoreCost": 350,
    "ComponentPartsCount": 0
  },
  "RelatedParts": [
    {
      "Id": 28533,
      "RelatedPartId": 4019191,
      "RelatedPartNumber": "RM00000051",
      "PartDescription": "ENGINE,S6E REMAN",
      "ImageUrl": null
    },
    {
      "Id": 28578,
      "RelatedPartId": 4019222,
      "RelatedPartNumber": "RM00000076",
      "PartDescription": "ENGINE S6E2 REMAN",
      "ImageUrl": null
    },
    {
      "Id": 28594,
      "RelatedPartId": 4019248,
      "RelatedPartNumber": "RM00000094",
      "PartDescription": "ENGINE S6S 60 REMAN",
      "ImageUrl": null
    },
    {
      "Id": 28607,
      "RelatedPartId": 4019273,
      "RelatedPartNumber": "RM00000113",
      "PartDescription": "ENGINE S6S 35 REMAN",
      "ImageUrl": null
    }
  ],
  "CoreDeductions": [
    {
      "Id": 3637,
      "PartId": 4019128,
      "DeductionType": {
        "Id": 151,
        "Description": "Fan"
      },
      "Value": 50,
      "SetValueToCoreCost": false
    },
    {
      "Id": 5437,
      "PartId": 4019128,
      "DeductionType": {
        "Id": 165,
        "Description": "Housing"
      },
      "Value": 150,
      "SetValueToCoreCost": false
    },
    {
      "Id": 7252,
      "PartId": 4019128,
      "DeductionType": {
        "Id": 243,
        "Description": "Pulley"
      },
      "Value": 50,
      "SetValueToCoreCost": false
    },
    {
      "Id": 9492,
      "PartId": 4019128,
      "DeductionType": {
        "Id": 248,
        "Description": "Vacuum pump"
      },
      "Value": 400,
      "SetValueToCoreCost": false
    }
  ],
  "CoreReturnPeriod": {
    "Rcc": "MA",
    "Description": "MCFA Reman",
    "StockMonths": "24",
    "EmergencyMonths": "6"
  },
  "EstimatedShipDates": [],
  "ExternalStockQuantities": [],
  "WarehouseStockQuantities": [
    {
      "PartId": 4019128,
      "WarehouseCode": "ON",
      "WarehouseDescription": "Ontario",
      "Quantity": 1,
      "PartSource": 1,
      "MCFCostCenter": 1,
      "WarehouseType": 1
    },
    {
      "PartId": 4019128,
      "WarehouseCode": "IN",
      "WarehouseDescription": "Indianapolis",
      "Quantity": 4,
      "PartSource": 1,
      "MCFCostCenter": 1,
      "WarehouseType": 1
    },
    {
      "PartId": 4019128,
      "WarehouseCode": "YO",
      "WarehouseDescription": "Easton",
      "Quantity": 0,
      "PartSource": 1,
      "MCFCostCenter": 1,
      "WarehouseType": 1
    },
    {
      "PartId": 4019128,
      "WarehouseCode": "TX",
      "WarehouseDescription": "Dallas",
      "Quantity": 2,
      "PartSource": 1,
      "MCFCostCenter": 1,
      "WarehouseType": 1
    }
  ],
  "QuantityBreakPrices": [],
  "ReturnabilityIndicator": 0,
  "IsSapReturnable": true,
  "IsMadeAsOrdered": false,
  "ContractPrice": 264,
  "PicCode": "605",
  "ItemClass": "RMA ",
  "IsDualStock": false,
  "IsInvalidPartWithNprAvailable": false,
  "PieceLengths": "",
  "EmergencyFeePercentage": 0,
  "PromoDiscounts": [],
  "ImageUrl": null,
  "OemId": 9,
  "Id": 4019128,
  "OemPartCode": "RM00000003",
  "SalesOrganization": 4,
  "McfCostCenterId": 1,
  "Weight": 18.03,
  "CaseQuantity": 1,
  "MaximumOrderQuantity": 0,
  "MinimumOrderQuantity": 1,
  "MinimumEmergencyOrderQuantity": 0,
  "NPRComments": null,
  "UnitOfMeasure": "EA",
  "FleetListPrice": 396,
  "DealerNetPrice": 264,
  "PricingEffectiveDate": "2019-04-06T00:00:00",
  "Company": "MCF",
  "PartDescription": "ALTERNATOR REMAN",
  "MarketingDescription": "24 Volt 30 Amp unit.",
  "CoreCost": 350,
  "PartSource": 0,
  "IsSuperseded": false,
  "HasMsdsInfo": false,
  "IsDropShip": false,
  "IsMcfStocked": false,
  "IsHazardous": false,
  "FreezeStatus": 0,
  "ItemCategory": "NORM",
  "IsMarkedDoNotSell": false,
  "IsReturnable": false,
  "IsSpecialOrder": false,
  "IsVendorNonStockProgram": false,
  "HazardCode": null
};

        switch (code) {
            case "ERR":
                return Mockios.fail(request, { message: "An expected error ocurred" });
            case "NOT FOUND":
                return Mockios.notFound(request);
            default:
                return Mockios.ok(request, RM00000063);
        }
    }

    private static getHistoryFactory(request: AxiosRequestConfig): AxiosPromise<IOrderHistoryByPart> {
        const code = oc(request.params as IGetPartDetailRequest).oemPartCode("NOT FOUND");

        switch (code) {
            case "NOT FOUND":
                return Mockios.notFound(request);
            case "1903-35003":
            case "RM00000063":
                return Mockios.ok(request, {
                    Orders: [],
                    Invoices: [],
                    Backorders: [],
                });
            default:
                return Mockios.ok(request, {
                    Orders: [
                        {
                            OrderNumber: "45667",
                            DealerCode: "15310",
                            SalesOrg: "MA",
                            OrderSource: "Rpi",
                            PONumber: "7894123",
                            OrderDate: "2019-09-18T00:00:00",
                        },
                    ],
                    Invoices: [
                        {
                            InvoiceId: 12389,
                            InvoiceSource: "Rpi",
                            OrderNumber: "45667",
                            InvoiceNumber: "7894123",
                            InvoiceDate: "2019-09-18T00:00:00",
                        },
                    ],
                    Backorders: [
                        {
                            OrderNumber: "45667",
                            OemPartCode: "REP9203",
                            PONumber: "7894123",
                            QuantityOrdered: 3,
                            QuantityBackordered: 2,
                            EstimatedShipDate: "2019-09-18T00:00:00",
                        },
                    ],
                });
        }
    }

    private static getComponentsFactory(request: AxiosRequestConfig): AxiosPromise<IPartDetailComponentInfo> {
        const code = oc(request.params as IGetPartDetailRequest).oemPartCode("NOT FOUND");

        switch (code) {
            case "NOT FOUND":
                return Mockios.notFound(request);
            case "RM00000063":
                return Mockios.ok(request, {
                    Components: [],
                    Usages: [],
                });
            case "1903-35003":
                return Mockios.ok(request, {
                    Components: [],
                    Usages: [
                        {
                            Serviceability: "Cancelled",
                            ServiceabilityImageUrl: "http://placeimg.com/16/16/tech",
                            OemPartCode: "14400-02290",
                            PartDescription: "KIT,VALVE LEVER",
                            SerialRange: "(N/A)",
                        },
                        {
                            Serviceability: "Separate",
                            ServiceabilityImageUrl: "http://placeimg.com/16/16/tech",
                            OemPartCode: "4690-55910",
                            PartDescription: "KIT,FRAM PIPING",
                            SerialRange: "(N/A)",
                        },
                        {
                            Serviceability: "Separate",
                            ServiceabilityImageUrl: "http://placeimg.com/16/16/tech",
                            OemPartCode: "MDI-910005",
                            PartDescription: "VALVE-ADD ON (4-WAY)",
                            SerialRange: "(N/A)",
                        },
                    ],
                });
            default:
                return Mockios.ok(request, {
                    Components: [
                        {
                            Serviceability: "Serviceable",
                            ServiceabilityImageUrl: "http://placeimg.com/16/16/tech",
                            OemPartCode: "1903-35003",
                            PartDescription: "BUSHING",
                            QuantityNeeded: 2,
                            EffectiveInDate: "1987-01-20",
                            EffectiveOutDate: null,
                        },
                        {
                            Serviceability: "Cancelled",
                            ServiceabilityImageUrl: "http://placeimg.com/16/16/tech",
                            OemPartCode: "1916-05002",
                            PartDescription: "O-RING",
                            QuantityNeeded: 2,
                            EffectiveInDate: "1987-01-20",
                            EffectiveOutDate: null,
                        },
                    ],
                    Usages: [],
                });
        }
    }

    private static getCrossReferencesFactory(request: AxiosRequestConfig): AxiosPromise<IPartCrossReferenceDto[]> {
        const code = oc(request.params as IGetPartDetailRequest).oemPartCode("NOT FOUND");

        switch (code) {
            case "NOT FOUND":
                return Mockios.notFound(request);
            case "RM00000063":
                return Mockios.ok(request, []);
            case "1903-35003":
                return Mockios.ok(request, [
                    {
                        PartNumber: "	1903-35003",
                        OemId: 1,
                        OemDescription: "CAT LIFT TRUCKS",
                        CrossOemListPrice: null,
                    },
                    {
                        PartNumber: "	1903-35003",
                        OemId: 1,
                        OemDescription: "MITSUBISHI FORKLIFTS",
                        CrossOemListPrice: null,
                    },
                ]);
            default:
                return Mockios.ok(request, [
                    {
                        PartNumber: "NF3446825100R",
                        OemId: 1,
                        OemDescription: "ATLET",
                        CrossOemListPrice: null,
                    },
                    {
                        PartNumber: "NF1032907R",
                        OemId: 1,
                        OemDescription: "ATLET",
                        CrossOemListPrice: null,
                    },
                    {
                        PartNumber: "NF3446825100R",
                        OemId: 1,
                        OemDescription: "BARRETT",
                        CrossOemListPrice: null,
                    },
                    {
                        PartNumber: "NF1032907R",
                        OemId: 1,
                        OemDescription: "BARRETT",
                        CrossOemListPrice: null,
                    },
                    {
                        PartNumber: "RM00000003",
                        OemId: 1,
                        OemDescription: "CAT LIFT TRUCKS",
                        CrossOemListPrice: null,
                    },
                ]);
        }
    }

    private static getPartApplicationsFactory(request: AxiosRequestConfig): AxiosPromise<IPartApplicationDto[]> {
        const code = oc(request.params as IGetPartDetailRequest).oemPartCode("NOT FOUND");

        switch (code) {
            case "NOT FOUND":
                return Mockios.notFound(request);
            default:
                return Mockios.ok(request, [
                    {
                        Id: 1,
                        PartId: 1,
                        OemCode: "",
                        OemDescription: "CAT LIFT TRUCKS",
                        ModelSeries: "DP40",
                        LotNumber: "",
                        SerialNumber: "3CM",
                        PartDescription: "ALTERNATOR - REMAN",
                    },
                    {
                        Id: 11,
                        PartId: 12,
                        OemCode: "",
                        OemDescription: "MITSUBISHI FORKLIFTS",
                        ModelSeries: "FD40-50K",
                        LotNumber: "",
                        SerialNumber: "AF19C",
                        PartDescription: "ALTERNATOR - REMAN",
                    },
                    {
                        Id: 111,
                        PartId: 122,
                        OemCode: "",
                        OemDescription: "NISSAN",
                        ModelSeries: "F04D",
                        LotNumber: "",
                        SerialNumber: "AN19C",
                        PartDescription: "ALTERNATOR - REMAN",
                    },
                ]);
        }
    }

    private static getSupersessionFactory(request: AxiosRequestConfig): AxiosPromise<IPartDetailSupersession> {
        const code = oc(request.params as IGetPartDetailRequest).oemPartCode("NOT FOUND");

        switch (code) {
            case "NOT FOUND":
                return Mockios.notFound(request);
            default:
                return Mockios.ok(request, {
                    ReplacingItems: [
                        {
                            OemPartCode: "FD40-50K",
                            ReplacementOemPartCode: "FD40-50K",
                            PartDescription: "MITSUBISHI FORKLIFTS",
                            PartQuantity: 1,
                            ReplacementPartQuantity: 1,
                        },
                    ],
                    Chains: [
                        {
                            Name: "Chain 01",
                            Items: [
                                { OemPartCode: "2322323", Type: "Interchangeable" },
                                { OemPartCode: "123", Type: "Interchangeable" },
                                { OemPartCode: "2322323", Type: "Interchangeable" },
                            ],
                        },
                        {
                            Name: "Chain 02",
                            Items: [
                                { OemPartCode: "53433", Type: "Interchangeable" },
                                { OemPartCode: "123", Type: "Interchangeable" },
                            ],
                        },
                        {
                            Name: "Chain 03",
                            Items: [
                                { OemPartCode: "7398233", Type: "Interchangeable" },
                                { OemPartCode: "123", Type: "Interchangeable" },
                            ],
                        },
                    ],
                });
        }
    }

    private static getGeneralPartInformation(code: string): IPartDetailGeneralInfo {
        switch (code) {
            case "RM00000063":
                return {
                    Description: null,
                    GeneralNotes: null,
                    AdditionalNotes: null,
                    OilNotes: null,
                    Returnable: "No",
                    PieceQuantities: null,
                    UnitOfMeasure: "EA",
                    SourceOfSupply: "MA",
                    EmergencyFee: "0%",
                    MSDSSheetLink: null,
                    Hazardous: "No",
                    PartsFastPartsFree: null,
                    CoreReturnPeriodStock: 24,
                    CoreReturnPeriodEmergency: 6,
                    PartAlternatives: null,
                };
            case "1903-35003":
                return {
                    Description: null,
                    GeneralNotes: null,
                    AdditionalNotes: null,
                    OilNotes: null,
                    Returnable: "No",
                    PieceQuantities: null,
                    UnitOfMeasure: "EA",
                    SourceOfSupply: "MA",
                    EmergencyFee: "0%",
                    MSDSSheetLink: null,
                    Hazardous: "No",
                    PartsFastPartsFree: null,
                    CoreReturnPeriodStock: null,
                    CoreReturnPeriodEmergency: null,
                    PartAlternatives: null,
                };
            default:
                return {
                    Description: "24 Volt 30 Amp unit.",
                    GeneralNotes: null,
                    AdditionalNotes: null,
                    OilNotes: null,
                    Returnable: "Yes",
                    PieceQuantities: null,
                    UnitOfMeasure: "EA",
                    SourceOfSupply: "RP",
                    EmergencyFee: "0%",
                    MSDSSheetLink: null,
                    Hazardous: "No",
                    PartsFastPartsFree: null,
                    CoreReturnPeriodStock: 24,
                    CoreReturnPeriodEmergency: 6,
                    PartAlternatives: [
                        {
                            OemPartCode: "3446825100",
                            PartType: "New",
                            Price: 804.74,
                            CurrencyCode: "USD",
                            ShowPrice: true,
                            IsContractPricing: true,
                        },
                    ],
                };
        }
    }

    private static getRelatedParts(code: string): IPartDetailRelatedPartItem[] {
        switch (code) {
            case "1903-35003":
            case "RM00000063":
                return [];
            default:
                return [
                    {
                        OemPartCode: "NF1032907R",
                        PartDescription: "ATLET",
                        ImageSrc: PartDetailMockService.placeholderImgUrl(60, 60),
                    },
                    {
                        OemPartCode: "RM00000003",
                        PartDescription: "CAT LIFT TRUCKS",
                        ImageSrc: PartDetailMockService.placeholderImgUrl(60, 60),
                    },
                ];
        }
    }

    private static getCoreDeductions(code: string): IPartDetailCoreDeductionItem[] {
        switch (code) {
            case "RM00000063":
                return [
                    { Description: "Control valve", DeductionAmount: 4000.0 },
                    { Description: "Out put shaft endplay", DeductionAmount: 4750.0 },
                    { Description: "Torque converter", DeductionAmount: 6700.0 },
                    { Description: "Piping", DeductionAmount: 750.0 },
                ];
            default:
                return [
                    { Description: "Fan", DeductionAmount: 50.0 },
                    { Description: "Housing", DeductionAmount: 150.0 },
                    { Description: "Pulley", DeductionAmount: 50.0 },
                    { Description: "Vacuum pump", DeductionAmount: 400.0 },
                ];
        }
    }

    private static placeholderImgUrl(width: number, height: number) {
        return `https://picsum.photos/${width}/${height}`;
    }

    private static placeholderImg(n: number) {
        const alt = `Image ${n}`;

        return {
            Src: `https://picsum.photos/seed/${n}/300/200`,
            Thumbnail: `https://picsum.photos/seed/${n}/60/40`,
            AltText: alt,
        };
    }

    private static PartDetailExample(): IPartDetailResponse {
     return
    }
}
